import { I18n } from "@ies/starling_intl";
import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import { debounce } from "lodash";
import Viewer from "react-viewer";
import { Link, useLocation, useHistory, useRouteMatch } from "react-router-dom";
import { Menu, Tooltip, message, Popover } from "antd";
import { api, verifyPermission } from "@/apis";
import logo from "@/assets/images/GameFlowIcon.png";
import { useCommonModel } from "@/models";
import { IconFont } from "@/components/IconFont";
import moment from "moment";
import UserAvatarNew from "./BugBind/UserAvatarNew";
import { handleHelpInfoIsShow, handleAccessibleRoutes } from "./utils";
import "./componentStyle.css";
import { ToolBoxDropdown, MyProjectModal } from "./HeaderComponents";
import {
  OVERVIEW_PATH,
  TEST_MANAGE_PATH,
  TOOL_PATH,
  AUTH_PATH,
} from "./siderMenu";
import { setLocale } from "@/common/starling";
import { languageData } from "./constantFile";
import { Dropdown, Select } from "@arco-design/web-react";
import {
  IconBook,
  IconCaretDown,
  IconPoweroff,
  IconQuestionCircle,
  IconRobotAdd,
  IconTool,
  IconUpload,
  IconUser,
  IconUserAdd,
} from "@arco-design/web-react/icon";

const { Option } = Select;

export const AppHeader: React.FC = () => {
  const [{ userInfo, projectInfo }, { setProjectInfo }] = useCommonModel();
  const [gmAuth, setGmAuth] = useState(false);
  const match = useRouteMatch("/:projectID");
  const location = useLocation();
  const history = useHistory();
  const [curAid, setCurAid] = useState(0);
  const [isCodeAdmin, setIsCodeAdmin] = useState(false);
  const { pathname } = useLocation();

  const id = useMemo(() => {
    if (match === null) {
      return 0;
    } else if ((match.params as any).projectID !== undefined) {
      try {
        return Number((match.params as any).projectID);
      } catch {
        return 0;
      }
    } else {
      return 0;
    }
  }, [pathname]);

  /** 当存档的项目在列表中没有找到的时候，通过调用项目详情的接口进行展示项目信息**/
  // const getProjectDetail = async (pid: number) => {
  //   try {
  //     if (pid) {
  //       await api.get(`/v1/projects/detail/${pid}`, {}).then(res => {
  //         setCurAid(res.review_meta.aid);
  //         if (
  //           ![2682, 362004, 6037].includes(res.review_meta.aid) &&
  //           window.location.pathname.includes("gm-config")
  //         ) {
  //           history.push(`/${pid}/testManagement/transferTask`);
  //         }
  //         if (
  //           res.archived === true &&
  //           !window.location.pathname.includes("issues")
  //         ) {
  //           message.error(I18n.t("item_deleted", {}, "项目已删除"));
  //           history.push("/my-project");
  //         } else {
  //           handleAccessibleRoutes(userInfo.userType, pathname, pid);
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     if (error?.code === 1000) {
  //       history.push("/my-project");
  //     }
  //   }
  // };

  const projectProcessing = () => {
    if (projectInfo?.id && projectInfo?.name) {
      // console.log(projectInfo,"projectInfo---")
      setCurAid(projectInfo.review_meta.aid);
      if (
        ![2682, 362004, 6037].includes(projectInfo.review_meta.aid) &&
        window.location.pathname.includes("gm-config")
      ) {
        history.push(`/${projectInfo?.id}/testManagement/transferTask`);
      }
      if (
        projectInfo.archived === true &&
        !window.location.pathname.includes("issues")
      ) {
        message.error(I18n.t("item_deleted", {}, "项目已删除"));
        history.push("/my-project");
      } else {
        handleAccessibleRoutes(userInfo?.userType, pathname, projectInfo?.id);
      }
    }
  };

  /** 查询是否具有GM工具权限 */
  const getGmToolRight = async (pid: number) => {
    if (pid) {
      const data = await api.get(
        `/v1/access_control/right/check_right?right_keys=right_gm_tool_read&project_id=${pid}`,
      );
      if (data) {
        setGmAuth(data.right_gm_tool_read);
        if (
          !data.right_gm_tool_read &&
          window.location.pathname.includes("gm-config") &&
          !userInfo?.isBpo
        ) {
          // history.push(`/${pid}/testManagement/transferTask`);
        }
      }
    }
  };

  /** 查询是否有覆盖率采集工具权限 */
  const codeCoverageAuth = async () => {
    const data = await api.get(
      `/v1/access_control/right/check_right?right_keys=right_code_coverage&project_id=0`,
    );
    if (data) {
      if (data.right_code_coverage) {
        setIsCodeAdmin(data.right_code_coverage);
      }
    }
  };

  useEffect(() => {
    // console.log(projectInfo,userInfo,"projectInfo----")
    if (
      ![
        "/login",
        "/signout",
        "/",
        "/download",
        "/noPermission/download",
      ].includes(location.pathname) &&
      !location.pathname.includes("/share") &&
      !location.pathname.includes("/summary")
    ) {
      // getProjectDetail(id);
      projectProcessing();
      getGmToolRight(id);
      codeCoverageAuth();
      if (
        [...OVERVIEW_PATH, ...AUTH_PATH].some(
          item =>
            location.pathname.includes(item) &&
            !userInfo?.isInternal &&
            !userInfo?.isBpo,
        ) &&
        !location.pathname.includes("storeManagement/ios/reveal-scan")
      ) {
        history.push("/my-project");
        message.warning(I18n.t("no_permission", {}, "无权限"));
      }
    }
  }, [pathname, userInfo, projectInfo]);

  const isTestManage = TEST_MANAGE_PATH.some(item =>
    location.pathname.includes(item),
  );
  // const needAuth = [...OVERVIEW_PATH, ...AUTH_PATH].some(item =>
  //   location.pathname.includes(item),
  // );
  const isToolBox = TOOL_PATH.some(item => location.pathname.includes(item));
  const [isShowHeader, setIsShowHeader] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  // const [iconIssueType, setIssueIconType] = useState('up');
  const [isShowUpdateNotification, setIsShowUpdateNotification] =
    useState(false);
  const [imgPreviewVisible, setImgPreviewVisible] = useState(false);
  const [announcementVersion, setAnnouncementVersion] = useState(false);
  const [announcementImg, setAnnouncementImg] = useState("");
  const [announcementTitle, setAnnouncementTitle] = useState("");
  const [announcementText, setAnnouncementText] = useState("");
  const [announcementUrl, setannouncementUrl] = useState("");
  const [projSelectVisible, setProjSelectVisible] = useState(false);
  const [curUrl, setCurUrl] = useState("/protection");
  const [projectList, setProjectList] = useState<
    {
      id: number;
      name: string;
      audit_state: number;
      icon: string;
      archived: boolean;
      is_default: boolean;
    }[]
  >([]);
  const [projectName, setProjectName] = useState("");
  const [isShowHeaderTab, setIsShowHeaderTab] = useState(false);

  useEffect(() => {
    if (
      !["/login", "/signout", "/", "/noPermission/download"].includes(
        location.pathname,
      ) &&
      !window.location.pathname.includes("/share") &&
      !window.location.pathname.includes("/summary")
    ) {
      getsuperPermissions();
    }
  }, []);
  useEffect(() => {
    if (
      !["/login", "/signout", "/", "/noPermission/download"].includes(
        location.pathname,
      ) &&
      !window.location.pathname.includes("/share") &&
      !window.location.pathname.includes("/summary")
    ) {
      searchProjectList();
      setProjectInfo({ id });
    }
  }, [id]);

  /** 拿到项目列表 */
  const searchProjectList = debounce(async () => {
    try {
      const data = await api.get("/v1/projects/mine", {});
      if (data) {
        const list = data.filter(
          item => item.audit_state === 2 && !item.archived,
        );
        setProjectList(list);
      }
    } catch {}
  }, 200);

  const ProjectValue = useMemo(() => {
    if (id) {
      if (
        projectList.find(item => {
          return item.id === id;
        })
      ) {
        return projectList.length && id ? id : undefined;
      } else {
        return projectName ? projectName : undefined;
      }
    } else {
      return undefined;
    }
  }, [projectList, id]);

  /** 查询是否具有超管权限（超管） */
  const getsuperPermissions = async () => {
    const data = await api.get(
      `/v1/access_control/right/check_right?right_keys=right_super_manager&project_id=0`,
    );
    if (data) {
      if (userInfo.id) {
        setIsAdmin(data.right_super_manager);
      }
    }
  };

  /** 查询有无最新公告通知 */
  const getAnnouncement = async () => {
    const data = await api.get("/v1/notice/announcement", {});
    if (data) {
      if (data.should_show) {
        setIsShowUpdateNotification(true);
      }
      setAnnouncementVersion(data.version);
      setAnnouncementImg(data.content.img);
      setAnnouncementTitle(data.content.title);
      setAnnouncementText(data.content.text);
      setannouncementUrl(data.content.detail_url);
    }
  };

  /** 设置公告已读 */
  const setAnnouncementRead = async () => {
    const param = {
      version: announcementVersion,
    };
    await api.post("/v1/notice/announcement_read", param);
  };

  useEffect(() => {
    // 需要隐藏上边菜单栏的页面
    const rootRoutes = [
      "/role-permissions-apply",
      "/login",
      "/signout",
      "/share",
      "/summary",
      "/download",
      "/review/google/internal-scan",
      "/noPermission/download",
    ];

    if (rootRoutes.some(item => location.pathname.includes(item))) {
      setIsShowHeader(false);
    } else {
      setIsShowHeader(true);
    }
    const hideHeaderRootRoutes = [
      "/project-detail",
      "/external-scan",
      "/external-flow-scan",
      "/external-google-scan",
      "/external-googleFlow-scan",
      "/my-project",
      "/online-market",
      "/project-progress",
      "/qa-weekly",
      "/online-quality",
      "/work-order",
      "/certs-management",
      "/privilegeManagement",
      "/new-project",
      "/issues",
      "/onlinestatus/list/apple",
      "/onlinestatus/list/google",
      "/onlinestatus/list/google_beta",
      "/allqareviewing/list",
      "/bpo-overview",
      "/bpo-data-entry",
      // '/operationManagement/issues/overview',
    ];
    if (
      hideHeaderRootRoutes.some(item => location.pathname.includes(item)) &&
      !location.pathname.includes("/operationManagement/issues/overview") &&
      !location.pathname.includes("/operationManagement/issues/process")
    ) {
      setIsShowHeaderTab(false);
    } else {
      setIsShowHeaderTab(true);
    }
    if (
      !["/login", "/signout", "/", "/noPermission/download"].includes(
        location.pathname,
      ) &&
      !location.pathname.includes("/interfacetest/sh") &&
      !location.pathname.includes("/share") &&
      !location.pathname.includes("/summary")
    ) {
      getsuperPermissions();
      getAnnouncement();
    }
  }, [location.pathname]);

  return (
    <Wrapper style={{ display: isShowHeader ? "flex" : "none" }}>
      <div>
        <AppLogo
          onClick={() => {
            // console.log('跳转');
            // history.push('/my-project');
            window.location.replace("/my-project");
          }}>
          <img src={logo} alt="GameFlow" width="200" height="44" />
        </AppLogo>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="projects_tabs">
          <ProjectSelect>
            <Select
              value={ProjectValue}
              suffixIcon={<IconCaretDown />}
              showSearch={true}
              // optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option &&
                  JSON.parse(option?.key)
                    .name.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
              style={{ width: 200, borderRadius: 12, height: 28 }}
              placeholder={I18n.t(
                "please_enter_a_project_name_2",
                {},
                "请输入项目名称",
              )}
              onChange={projectID => {
                setProjectInfo({ id: projectID });
                if (userInfo?.userInfo?.userType !== 5) {
                  history.push(`/${projectID}/testManagement/transferTask`);
                } else {
                  history.push(`/${projectID}/testManagement/wrapManage`);
                }
              }}
              dropdownMenuClassName="searchNamecss">
              {projectList.map(item => {
                return (
                  <Option
                    key={JSON.stringify({ id: item.id, name: item.name })}
                    value={item.id}
                    style={{
                      backgroundColor: item.is_default
                        ? "rgba(0, 0, 0, 0.08)"
                        : "",
                    }}>
                    {item.name.length > 15 ? (
                      <>
                        <Tooltip title={item.name}>{item.name}</Tooltip>
                      </>
                    ) : (
                      <>{item.name}</>
                    )}
                  </Option>
                );
              })}
            </Select>
          </ProjectSelect>
          {isShowHeaderTab ? (
            <>
              <MenuItem
                $active={isTestManage && !isToolBox}
                to={`/${id}/testManagement/transferTask`}
                onClick={() => (window.MENU_STATE.openKeys = ["transferTask"])}>
                {I18n.t("process_management", {}, "流程管理")}
              </MenuItem>
            </>
          ) : null}
          <MenuItem
            $active={isToolBox}
            to={"/"}
            onClick={e => {
              e.preventDefault();
            }}>
            <Dropdown
              position="bl"
              trigger={["click"]}
              // disabled={!id}
              droplist={
                <ToolBoxDropdown
                  gmRight={gmAuth || userInfo?.userInfo?.isBpo}
                  codeAuth={isCodeAdmin}
                  curAid={curAid}
                  userInfo={userInfo}
                  setUrl={setCurUrl}
                  setVisible={setProjSelectVisible}
                  id={id}
                />
              }>
              <div style={{ marginLeft: "0.5rem" }}>
                {I18n.t("toolbox", {}, "工具箱")}
              </div>
            </Dropdown>
          </MenuItem>
        </div>
      </div>
      <div>
        <Select
          style={{ width: 100 }}
          className="language_wrapper"
          value={localStorage.getItem("I18N_STATUS")}
          defaultValue={userInfo?.userInfo?.userType !== 5 ? "zh-CN" : "en"}
          onChange={value => {
            if (value) {
              setLocale(value);
              window.location.reload();
            }
          }}>
          {languageData.map(item => {
            return (
              <Option value={item.key} key={item.key}>
                {item.value}
              </Option>
            );
          })}
        </Select>
        {userInfo?.userInfo?.userType !== 0 &&
        userInfo?.userInfo?.userType !== 5 ? (
          <Popover
            content={
              <UpdatePopoverBox>
                {announcementImg ? (
                  <div className="update-notification-img-box">
                    <img
                      src={announcementImg}
                      className="update-notification-img"
                      onClick={() => {
                        setImgPreviewVisible(true);
                        setIsShowUpdateNotification(false);
                      }}
                    />
                  </div>
                ) : null}
                <div
                  className="update-notification-title"
                  style={{ marginTop: announcementImg ? "10px" : "0px" }}>
                  {announcementTitle}
                </div>
                <div
                  className="update-notification-content"
                  style={{ whiteSpace: "pre-wrap" }}
                  dangerouslySetInnerHTML={{ __html: announcementText }}></div>
                <div className="update-notification-footer">
                  <div
                    className="update-notification-footer-btn"
                    style={{
                      lineHeight: "24px",
                      boxSizing: "border-box",
                      border: "1px solid #ffffff",
                      color: "#ffffff",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      setIsShowUpdateNotification(false);
                      setAnnouncementRead();
                    }}>
                    {I18n.t("i_see_", {}, "我知道了")}
                  </div>
                  <div
                    className="update-notification-footer-btn"
                    style={{
                      lineHeight: "26px",
                      background: "#ffffff",
                      color: "#282f38",
                    }}
                    onClick={() => {
                      setIsShowUpdateNotification(false);
                      setAnnouncementRead();
                      window.open(
                        announcementUrl === ""
                          ? "https://bytedance.feishu.cn/docs/doccnM7PsSJJW50w1lquFtAsZ0e"
                          : announcementUrl,
                      );
                    }}>
                    {I18n.t("view_details", {}, "查看详情")}
                  </div>
                </div>
              </UpdatePopoverBox>
            }
            overlayClassName="update-notification-popover"
            placement="bottomRight"
            visible={isShowUpdateNotification}>
            <div
              style={{
                padding: "0px 8px",
                display: "flex",
                justifyContent: "center",
              }}>
              <Tooltip
                placement="bottom"
                title={I18n.t("feature_update", {}, "功能更新")}>
                <IconFont
                  type="icondengpao-copy"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsShowUpdateNotification(true);
                  }}
                />
              </Tooltip>
            </div>
          </Popover>
        ) : null}
        <Viewer
          visible={imgPreviewVisible}
          onClose={() => {
            setImgPreviewVisible(false);
            setIsShowUpdateNotification(true);
          }}
          images={[{ src: announcementImg, alt: "" }]}
          drag={false}
          noFooter={false}
          showTotal={false}
          changeable={false}
        />
        {handleHelpInfoIsShow(userInfo?.userInfo?.userType)}
        <UserAvatar isAdmin={isAdmin} />
      </div>
      <MyProjectModal
        visible={projSelectVisible}
        setVisible={setProjSelectVisible}
        url={curUrl}
        projects={projectList}
      />
    </Wrapper>
  );
};

const UpdatePopoverBox = styled.div`
  width: 310px;
  color: #ffffff;
  flex-direction: column;
  .update-notification-img-box {
    /* padding: 5px; */
    /* background: #ffffff; */
    display: flex;
    justify-content: center;
    .update-notification-img {
      width: 310px;
      height: 177px;
      border-radius: 5px;
    }
  }
  .update-notification-title {
    font-size: 16px;
    letter-spacing: 0.5px;
  }
  .update-notification-content {
    margin-top: 6px;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 26px;
    p {
      margin-bottom: 0px;
    }
  }
  .update-notification-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    .update-notification-footer-btn {
      width: 74px;
      height: 26px;
      border-radius: 2px;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
    }
  }
`;

/** 用户头像信息 */
const UserAvatar: React.FC<{
  isAdmin: boolean;
}> = ({ isAdmin }) => {
  // const [{ userInfo }] = useCommonModel();
  const [userInfo, setUserInfo] = useState<any>();
  const [showUserNotice, setShowUserNotice] = useState(false);
  const [showJurisdiction, setShowJurisdiction] = useState(false);
  const [isShowAvatar, setIsShowAvatar] = useState(false);
  const timer = useRef() as any;
  /** 小红点的添加 */
  const showLittleRed = () => {
    return api
      .get("/v1/projects/notice_point", {
        noErrorMessage: false,
      })
      .then(res => {
        if (res?.notice) {
          setShowUserNotice(true);
          setShowJurisdiction(true);
        } else {
          setShowUserNotice(false);
          // setShowSystem(false);
          setShowJurisdiction(false);
        }
      });
    // }, 5000);
  };

  const searchUserInfo = async () => {
    const data = await api.get("/v1/users/self", {});
    if (data) {
      setUserInfo(data.user);
      if (data.user.avatar_url) {
        setIsShowAvatar(true);
      }
    }
  };

  useEffect(() => {
    if (
      ![
        "/login",
        "/signout",
        "/",
        "/download",
        "/noPermission/download",
      ].includes(window.location.pathname) &&
      !window.location.pathname.includes("/share") &&
      !window.location.pathname.includes("/summary")
    ) {
      searchUserInfo();
      showLittleRed();
      timer.current = setInterval(() => {
        showLittleRed();
      }, 5000);
      return () => {
        clearInterval(timer.current);
      };
    } else {
      return () => null;
    }
  }, [window.location.pathname]);

  return (
    <>
      {!["/login", "/signout", "/", "/terms", "/privacy-policy"].includes(
        window.location.pathname,
      ) &&
        !window.location.pathname.includes("/share") &&
        !window.location.pathname.includes("/summary") && (
          <Dropdown
            droplist={
              <DropdownMenu
                user={userInfo}
                showJurisdiction={showJurisdiction}
                isAdmin={isAdmin}
              />
            }>
            <div
              style={{
                marginTop: "2px",
                display: "flex",
                justifyContent: "flex-start",
                cursor: "pointer",
              }}
              className="dropBox">
              {isShowAvatar ? (
                <div style={{ padding: "0 10px", marginTop: "-4px" }}>
                  <UserAvatarNew
                    url={userInfo?.avatar_url}
                    name={userInfo?.nickname}
                    size={24}
                    scale={0.8}
                  />
                </div>
              ) : null}
              {!isShowAvatar ? (
                <div style={{ padding: "0 10px", marginTop: "-3px" }}>
                  <UserAvatarNew
                    url={""}
                    name={userInfo?.nickname}
                    size={24}
                    scale={0.8}
                  />
                </div>
              ) : null}
              {showUserNotice ? <span className="drop"></span> : null}
            </div>
          </Dropdown>
        )}
    </>
  );
};

/** 帮助 */
export const HelpInfo: React.FC = () => {
  const [{ userInfo }] = useCommonModel();
  const onCallUrl = ids =>
    `https://applink.feishu.cn/client/helpdesk/open?id=6825574685258940418&extra={"human_service":true,"appointed_agent_ids":[${ids}]}`;
  const larkGroupUrl =
    "https://applink.feishu.cn/client/chat/open?chatId=6761008558587822350";
  const manualUrl = !userInfo?.isBpo
    ? "https://bytedance.feishu.cn/docs/doccnfrU2MYh7VyH07JxgvHw3Xd#"
    : "https://bytedance.feishu.cn/docx/Z7RXd6sYIo7BbNxsMWQcc63Vnhb";
  const helpHTML = () => {
    return (
      <Help>
        <div className="modal-container">
          <div className="title">
            <div>{I18n.t("help_and_feedback", {}, "帮助与反馈")}</div>
          </div>
          <div className="sectorization">
            <div className="sectorizationBox">
              <div className="sectorizationImgBox">
                <IconUpload />
              </div>
              <div className="sectorizationC">
                <div className="sectorizationText">
                  OnCall
                  <Tooltip
                    className="nameTitle"
                    title={
                      <div style={{ width: 240 }}>
                        {I18n.t(
                          "if_you_encounter_functional_problems_in_use__you_can_click_to_report__and_we_wil",
                          {},
                          "如您在使用中遇到了功能性问题,可以点击上报,我们将尽快为您解决。",
                        )}
                      </div>
                    }
                    getPopupContainer={(triggerNode: any) => {
                      return triggerNode.parentNode;
                    }}>
                    <IconQuestionCircle />
                  </Tooltip>
                </div>
                <div className="sectorizationCase">
                  <span onClick={onCall}>
                    {I18n.t("start_consultation", {}, "开始咨询")}
                  </span>
                </div>
              </div>
            </div>
            <div className="sectorizationBox" style={{ marginTop: "10px" }}>
              <div className="sectorizationImgBox">
                <IconBook />
              </div>
              <div className="sectorizationC">
                <div className="sectorizationText">
                  {I18n.t("help_documentation", {}, "帮助文档")}
                </div>
                <div className="sectorizationCase">
                  <a
                    target="_blank"
                    href={manualUrl}
                    style={{ color: "#3370ff" }}>
                    {I18n.t("gameflow_user_manual", {}, "GameFlow用户手册")}
                  </a>
                </div>
              </div>
            </div>
            <div className="sectorizationBox" style={{ marginTop: "10px" }}>
              <div className="sectorizationImgBox">
                <IconRobotAdd />
              </div>
              <div className="sectorizationC">
                <div className="sectorizationText">
                  {I18n.t("lark_plus_group", {}, "Lark 加群")}
                </div>
                <div className="sectorizationCase">
                  <span onClick={joinLarkGroup}>
                    {I18n.t("click_to_add_group", {}, "点击加群")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Help>
    );
  };
  /** 开始咨询 */
  const onCall = () => {
    let ids = "";
    if (location.pathname.includes("recommend")) {
      // 商店推荐模块onCall人员
      ids =
        "6800154501618614274,6848788125997613057,6780140128456147212,6809805358249295874";
    } else if (
      location.pathname.includes("review") ||
      location.pathname.includes("certManage")
    ) {
      // 商店提审及商店其他模块onCall人员
      ids =
        "6817974207482167298,6862886268720644098,6968647510327885852,6979783347555958812,6780140128456147212,6809805358249295874,6895544696827953154";
    } else {
      // 转测及其他模块onCall人员
      ids =
        "6849527356365815810,6882565193021374465,6992025364453408769,6982011746382823425,6809805358249295874,6765667911454425347,6747484850145460491,6895544696827953154";
    }
    window.open(onCallUrl(ids));
  };

  /** Lark 加群 */
  const joinLarkGroup = async () => {
    const data = await api.post<{ is_member_in: boolean }>(
      "/v1/lark/group/users",
    );
    message.success(
      data.is_member_in
        ? I18n.t("you_are_already_in_the_group_", {}, "您已经在群里了")
        : I18n.t("join_the_group_successfully", {}, "加群成功"),
    );
    window.open(larkGroupUrl);
  };
  return (
    <div
      style={{
        padding: "3px 8px 3px 10px",
        display: "flex",
        justifyContent: "center",
        cursor: "pointer",
        borderRight: "1px solid rgba(255,255,255,0.25)",
      }}>
      <Dropdown droplist={helpHTML()} position="br">
        <IconFont type="iconzixun" style={{ fontSize: "16px" }} />
      </Dropdown>
    </div>
  );
};

/** 用户头像处弹出菜单 */
const DropdownMenu: React.FC<{
  user: any;
  showJurisdiction: boolean;
  isAdmin: boolean;
}> = ({ user, showJurisdiction, isAdmin }) => {
  const history = useHistory();
  const [, { clearUserInfo }] = useCommonModel();
  const jumpToTicketSystem = async () => {
    if (await verifyPermission("right_site_ticket_page_read", 0)) {
      history.push("/work-order");
    }
  };

  const logout = () => {
    clearUserInfo();
    history.push("/signout");
  };

  return (
    <DropdownMenuWrapper className="usermenu">
      {user.is_internal || user.is_bpo ? (
        <Menu.Item
          style={{
            position: "relative",
          }}>
          <div
            style={{
              padding: "0 7px",
              marginRight: "3px",
              color: "rgb(0,0,0,0.55)",
            }}
            onClick={() =>
              history.push(
                `/qa-weekly?startDate=${moment()
                  .add("days", -7)
                  .startOf("days")
                  .unix()}&endDate=${moment()
                  .add("days", -1)
                  .endOf("days")
                  .unix()}`,
              )
            }>
            <IconTool />
            <span>{I18n.t("management_center", {}, "管理中心")}</span>
          </div>
        </Menu.Item>
      ) : null}
      <Menu.Item
        style={{
          position: "relative",
        }}
        onClick={() =>
          history.push("/privilegeManagement/addPrivilegeManagement")
        }>
        <div
          style={{
            padding: "0 7px",
            marginRight: "3px",
            color: "rgb(0,0,0,0.55)",
          }}>
          <IconUserAdd />
          <span>{I18n.t("rights_management", {}, "权限管理")}</span>
          {showJurisdiction ? <span className="redSpot"></span> : null}
        </div>
      </Menu.Item>
      {user.user_type && user.user_type === 4 && (
        <Menu.Item onClick={() => history.push("/personal-information")}>
          <div
            style={{
              padding: "0 7px",
              marginRight: "3px",
              color: "rgb(0,0,0,0.55)",
            }}>
            <IconUser />
            <span>{I18n.t("personal_center", {}, "个人中心")}</span>
          </div>
        </Menu.Item>
      )}
      <Menu.Divider />
      <Menu.Item onClick={logout}>
        <div
          style={{
            padding: "0 7px",
            marginRight: "3px",
            color: "rgb(0,0,0,0.55)",
          }}>
          <IconPoweroff />
          <span>{I18n.t("logout_login", {}, "退出登录")}</span>
        </div>
      </Menu.Item>
    </DropdownMenuWrapper>
  );
};

const DropdownMenuWrapper = styled(Menu)`
  .ant-menu-item {
    margin: 0 !important;
    height: 32px !important;
    line-height: 32px !important;
    .arco-icon {
      margin-right: 10px;
    }
  }
  .redSpot {
    position: absolute;
    top: 7px;
    right: 12px;
    display: block;
    width: 7px;
    height: 7px;
    background: red;
    border-radius: 50%;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #282f38;
  color: rgba(255, 255, 255, 0.65);
  overflow: auto;
  & > div {
    display: flex;
    align-items: center;
  }
  .language_wrapper {
    .arco-select-view {
      background: none;
      color: #ffffff;
      border: none;
    }
    .arco-select-arrow-icon,
    .arco-select-view-value {
      color: #ffffff !important;
    }
  }

  a {
    color: inherit;
    &:hover {
      color: #fff;
    }
  }
  .dropBox {
    position: relative;
    .drop {
      position: absolute;
      top: -4px;
      width: 7px;
      height: 7px;
      background: red;
      border-radius: 50%;
      left: 34px;
    }
  }
  .projects_tabs {
    > a {
      &:before {
        left: 2px;
        width: -webkit-fill-available;
      }
    }
    > a:last-child {
      &:before {
        left: 13px;
      }
    }
  }
`;

const AppLogo = styled.div`
  cursor: pointer;
`;

export const MenuItem = styled(Link)<{ $active?: boolean }>`
  display: inline-block;
  padding: 0 20px;
  /* background-color: ${props => (props.$active ? "#1890ff" : "initial")}; */
  color: ${props => (props.$active ? "#fff !important" : "")};
  font-size: 16px;
  line-height: 44px;
  position: relative;
  &::before {
    content: "";
    width: 70px;
    height: 2px;
    bottom: 1px;
    left: 17px;
    display: ${props => (props.$active ? "balck" : "none")};
    background-color: rgb(255 255 255);
    position: absolute;
  }
`;
const ProjectSelect = styled.span`
  padding: 0 20px;
  .arco-select-view {
    height: 28px !important;
    border: 0;
    border-radius: 20px;
    background-color: rgb(63 68 83) !important;
    .arco-select-suffix-icon,
    .arco-select-view-value {
      color: #ffffff !important;
    }
  }
`;
const LinkButton = styled(Link)`
  margin: 0 3px;
  padding: 4px 12px 3px;
  font-size: 14px;
`;
const Help = styled.div`
  .modal-container {
    background: #ffffff;
    box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
    border-radius: 3px;
    margin-top: 3px;
    .title {
      font-size: 16px;
      padding: 0 20px;
      line-height: 50px;
      display: flex;
      .close {
        flex: 1;
        justify-items: right;
        text-align: right;
        color: #d9d9d9;
      }
    }
    .ant-tooltip {
      width: 248px;
    }
  }

  .sectorization {
    padding: 0 10px 10px 10px;
    .sectorizationBox {
      padding: 10px;
      background-color: #f8f9fa;
      display: flex;

      .sectorizationImgBox {
        width: 41px;
        height: 41px;
        border-radius: 50%;
        margin-right: 10px;
        border: 1px solid #e4e5e7;
        text-align: center;
        line-height: 41px;
        color: #939aa3;
        font-size: 18px;
      }

      .sectorizationC {
        position: relative;
        .sectorizationText {
          margin-bottom: 5px;
        }
        .sectorizationCase {
          margin-bottom: 5px;
          color: #3370ff;
          span {
            cursor: pointer;
          }
        }
      }
    }
  }
`;
